import { 
    ShareBaseDialog
} from 'sharebase/domain';

const template = require('./confirmDialog.template');
export class ConfirmDialog extends ShareBaseDialog {
	public static $inject: string[] = [
		'$mdDialog',
		'gettextCatalog'
	];

	public detail:string;
	public confirmButtonText:string;
	public cancelButtonText:string;

	constructor(
		$mdDialog,
		private gettextCatalog:ng.gettext.gettextCatalog
	){
		super($mdDialog, template, '', false);
		this.setDefault();
	}

	public open(e:ng.IAngularEvent, detail:string, title?:string, confirmButtonText?:string, cancelButtonText?:string){
		this.setDefault();
		this.detail = detail;
		this.title = title || this.title;
		this.confirmButtonText = confirmButtonText || this.confirmButtonText;
		this.cancelButtonText = cancelButtonText || this.cancelButtonText;
		
		return super.open(e);
	}

	public dismiss(value:boolean){
		super.dismiss(value);
	}

	/**
	 * Services in Angular are singletons, so any valuse from a previous use must be reset.
	 */
	private setDefault(){
		this.title = this.gettextCatalog.getString('Confirm');
		this.detail = '';
		this.confirmButtonText = this.gettextCatalog.getString('Continue');
		this.cancelButtonText = this.gettextCatalog.getString('Cancel');
	}
}


// WEBPACK FOOTER //
// ./src/sharebase/components/confirmDialog/confirmDialog.ts